import $ from 'jquery';

var initLocationButton = function ($button) {

    $button.on("click", function () {
        var $this = $(this);
        var $map = $(this).find(".zmpcm-map");
        $map.addClass("map-visible");
        var gm = $("body").googlemapsManager("createMap", $map);
        gm.setmarkerposition($map.attr("data-lat"), $map.attr("data-lon"));
        $this.off("click");
    });

}

export function initGoogleMaps() {

    $("body").googlemapsManager();

    $(".zmpcm-feed").on("zmp-feed-item-rendered", function (e, $item) {

        $item.find(".event-location,.jobopening-location").each(function (index, obj) {
            var _$this = $(this);
            initLocationButton(_$this);
        });

    });

}
